import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authSession } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double-processing under React StrictMode.
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;

    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const ref_code = (() => {
          try { return localStorage.getItem("gamma_pending_ref") || undefined; }
          catch { return undefined; }
        })();
        await authSession(session_id, ref_code);
        // Clear ref after successful exchange — backend records it on first signup.
        try { localStorage.removeItem("gamma_pending_ref"); } catch { /* ignore */ }
        await refresh();
      } catch (e) {
        console.error("auth exchange failed", e);
      } finally {
        // Strip the hash and bounce to dashboard.
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
        <div className="text-sm text-white/60">Signing you in…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
